package org.zest.insan_360_website.data.page_states

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

data class ResetPasswordState(
    val newPassword: String = "",
    val confirmPassword: String = "",
    val isProcessing: Boolean = false
)

object ResetPasswordPageState {
    var state by mutableStateOf(ResetPasswordState())

    fun reset() {
        state = ResetPasswordState()
    }
}
